module.exports = __webpack_public_path__ + "static/media/photo259.6000365a.jpg";